import request from '../utils/request'

export function querySongs(keyword, sign, timestamp,page,size) {
    return request({
        url: '/wx/es/song',
        method: 'get',
        params: {
            'keyword': keyword,
            'sign': sign,
            'timestamp': timestamp,
            'pageNo': page,
            'pageSize': size,
        }
    })
}
export function queryQuark(keyword, sign, timestamp,page,size) {
    return request({
        url: '/wx/es/quark',
        method: 'get',
        params: {
            'keyword': keyword,
            'sign': sign,
            'timestamp': timestamp,
            'pageNo': page,
            'pageSize': size,
        }
    })
}
